import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 px-4 md:px-8 bg-nightBlueLighter relative overflow-hidden" data-id="element-140">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-142">
          <div className="inline-flex justify-center mb-8" data-id="element-143">
            <MoonIcon className="w-12 h-12 text-teal opacity-80" data-id="element-144" />
          </div>

          <p className="font-playfair font-bold text-2xl md:text-3xl text-warmWhite leading-relaxed mb-8" data-id="element-145">
            En solo 7 días, tu cuerpo dejará de luchar contra el insomnio y
            empezará a trabajar a tu favor.
          </p>

          <p className="font-lato text-lg md:text-xl text-warmWhite/80 leading-relaxed" data-id="element-146">
            No es una promesa vacía: es el resultado de alinear tu temperatura y
            tus hormonas con el ciclo natural del día. Verás cómo la neblina
            mental desaparece y recuperas la energía que creías perdida por la
            edad.
          </p>
        </motion.div>
      </div>
    </section>;
}